import { DeliveryMethod } from './delivery-method.model';
import { SessionMap } from './session-map.model';
import { Status } from './status.model';
import moment from 'moment';

export class CourseSession {
    id: number;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    checkInDate: string;
    minAttendance: number;
    maxAttendance: number;
    sortOrder: number;
    required: boolean;
    status: Status;
    deliveryMethod: DeliveryMethod;
    topicKeywords: string;
    privateUrl: string;
    eedsAin: string;
    landingPage: boolean;
    joinUrl: string;
    integrations: { [name: string]: SessionMap} = {};
    userAttendance: boolean;

    constructor(data) {
        this.id = data.session_pk ? parseInt(data.session_pk) : null;
        this.name = data.session_name ? data.session_name : null;
        this.description = data.session_description ? data.session_description : null;
        this.startDate = data.session_begin_ts ? moment(data.session_begin_ts).format('MM/DD/YYYY hh:mm:ss A') : null;
        this.endDate = data.session_end_ts ? moment(data.session_end_ts).format('MM/DD/YYYY hh:mm:ss A') : null;
        this.checkInDate = data.check_in_ts ? moment(data.check_in_ts).format('MM/DD/YYYY hh:mm:ss A') : null;
        this.status = data.casce_status ? new Status(data.casce_status) : new Status({});
        this.minAttendance = data.min_attendance ? parseInt(data.min_attendance) : null;
        this.maxAttendance = data.max_attendance ? parseInt(data.max_attendance) : null;
        this.sortOrder = data.sort_order ? parseInt(data.sort_order) : null;
        this.required = data.required ? (data.required === "1") : null;
        this.deliveryMethod = data.casce_delivery_method ? new DeliveryMethod(data.casce_delivery_method) : new DeliveryMethod({});
        this.topicKeywords = data.topic_keywords ? data.topic_keywords : null;
        this.privateUrl = data.private_url ? data.private_url : null;
        this.eedsAin = data.eeds_ain ? data.eeds_ain : null;
        this.landingPage = (data.casce_landing_page && data.casce_landing_page.value != 1) ? false : true;
        this.joinUrl = data.casce_join_url ? data.casce_join_url.value : null;
        
        if (data.casce_session_map) {
            data.casce_session_map.forEach(map => {
                this.integrations[map.application] = new SessionMap(map);
            });
        }

        this.userAttendance = (data.attendance && data.attendance.status) ? data.attendance.status : false;

    }
}
